// Climate-Sensor-Liste fuer /zuhause/sensoren/insight (Climate.svelte): die
// Geräte mit Temperatur/Feuchte/Druck/Batterie/Funk (ClimateDevice, wie
// /v2-api/climate). Aggregat-Status-Store ist klima-summary (KlimaSensor mit
// metrics-Map), der bedient die Sensoren-Liste + Dashboard-Karte.
//
// Datenfluss: kein eigener Abruf mehr -- die Liste kommt aus dem gemeinsamen
// Sensoren-Stand (lib/sensoren.svelte.ts), den das Homelab-Protokoll (Topic
// sensor.stand, docs/protokoll.md › „Sensoren über das Protokoll“) speist.
// REST nur beim Start, als Revalidator, nach Aktionen und als Neuversuch --
// dort. Bis 02.11.2026 holte dieser Store alle 10 s (und bei jedem WS-Signal
// "climate") GET /v2-api/climate.

import { getKlimaGeraete, refreshSensoren, startSensoren } from "./sensoren.svelte";
import type { ClimateDevice } from "./types";

let _aus: (() => void) | undefined;

export function startClimateDevices(): void {
  if (_aus) return;
  _aus = startSensoren();
}

export function stopClimateDevices(): void {
  _aus?.();
  _aus = undefined;
}

export function getClimateDevices(): ClimateDevice[] | undefined {
  return getKlimaGeraete();
}

export function refreshClimateDevices(): Promise<void> {
  return refreshSensoren("klima");
}
